import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import InfoMeType from "./actionTypes"

import moment from "moment"
import correctionAPI from "helpers/correction_backend_helper"
import InfoMeAction from "./actions"
import { getInfoMeAPI } from "helpers/users_backend_helper"

function* fetchDetail() {
  yield put(
    InfoMeAction.getInfoMeSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(getInfoMeAPI)
    yield put(
      InfoMeAction.getInfoMeSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      InfoMeAction.getInfoMeSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* infoMeSaga() {
  yield takeEvery(InfoMeType.GET_INFO_ME_2, fetchDetail)
}

export default infoMeSaga
